import { getAxiosInstance } from 'src/lib/axios';

import { ENV, getConfig } from '../global-config';

//Interceptors are added in Main Axios file src/lib/axios.ts

export const networkCall = (
    type: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endUrl: string,
    baseUrl: string,
    includeId: boolean = true,
    header: boolean = true,
    data: any = undefined!,
    instanceId?: any,
    config?: any,
    fullResponse?: boolean,
    customHeaders?: any,
    dynamicUrlData?: string,
    replaceableUrlData?: Record<string, string>,
    callback?: (data: any, success: boolean) => void
) => {
    const axiosInstance = getAxiosInstance();
    let fullUrl: string = '';

    //Add some logic to fetch baseurl from some config file
    fullUrl = getURL(baseUrl, endUrl, dynamicUrlData, replaceableUrlData);

    //const SECRET_KEY = CONFIG[ENV].secretKey;
  
    let headers: object = {};

    // if (header) {
    //     if (SECRET_KEY) {
    //         headers = {
    //             'HR-Secret-Id': SECRET_KEY,
    //             'Content-Type': 'application/json',
    //             'Accept': 'application/json',
    //         };
    //     }
    // } 
    if (typeof customHeaders != 'undefined' && customHeaders != null) {
        headers = customHeaders;
    }

    const axiosRequestConfig = {
        method: type,
        url: fullUrl,
        baseURL: baseUrl,
        headers: {
            ...headers,
        },
        ...config,
    };
    
    if (type === 'GET') {
        axiosRequestConfig.params = data;
    } else {
        axiosRequestConfig.data = data;
    }

    return new Promise((res: any, rej: any) => {

        axiosInstance(axiosRequestConfig)
            .then((result: any) => {
                if (fullResponse) {
                    res(result);
                }
                if (callback) {
                    callback(result.data, true);
                }
                res(result.data);
            })
            .catch(function (error) {
                if (callback) {
                    callback(error, false);
                }
                rej(error);
            });
    });
};

//TODO: Change logic to handle the replaceables in URL
export const getURL = (
    baseUrl: string,
    endUrl: string,
    dynamicUrl?: string,
    replaceableUrl?: Record<string, string>
): string => {
    const CONFIG = getConfig();
    
    let fullUrl: string = '';

    // Add base URL
    if (baseUrl) {
        fullUrl += baseUrl;
    } else {
        fullUrl += CONFIG[ENV].baseUrl;
    }

    // Add end URL
    fullUrl += endUrl;

    // Add dynamic URL if present
    if (dynamicUrl) {
        fullUrl += dynamicUrl;
    }

    return fullUrl;
};